import { _ep0, _mw0, command } from "../commandBuilder";
import { ListCurrentUserRegistration$ } from "../schemas/schemas_0";
export class ListCurrentUserRegistrationCommand extends command(_ep0, _mw0, "ListCurrentUserRegistration", ListCurrentUserRegistration$) {
}
